import React from 'react';
import { Image, Link, Text, View } from '@react-pdf/renderer';
import { extLinkImg } from '../imgData';
import { pdfStyles } from '../pdfStyles';
import { Style } from '@react-pdf/types';

const URL_PATTERN = /(?:https?:\/\/|www\.)[^\s<>"')\]]+/gi;

const isUrl = (text: string) => /^(?:https?:\/\/|www\.)[^\s<>"')\]]+$/i.test(text);

const normalizeHref = (url: string) => (url.startsWith('www.') ? `https://${url}` : url);

const flattenStyle = (style: Style | Style[]): Style[] => (Array.isArray(style) ? style : [style]);

interface PdfLinkifyTextProps {
  children: string | null | undefined;
  style?: Style | Style[];
}

export const PdfLinkifyText: React.FC<PdfLinkifyTextProps> = ({ children, style = pdfStyles.value }) => {
  if (!children) {
    return null;
  }

  const parts = children.split(new RegExp(`(${URL_PATTERN.source})`, 'gi'));

  const hasUrls = parts.some((part) => isUrl(part));

  if (!hasUrls) {
    return <Text style={style}>{children.split('')}</Text>;
  }

  const baseStyles = flattenStyle(style);

  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center' }}>
      {parts.flatMap((part, index) =>
        isUrl(part)
          ? [
              ...part.split('').map((char, charIndex) => (
                <Link key={`${index}-${charIndex}`} src={normalizeHref(part)} style={{ textDecoration: 'none' }}>
                  <Text style={[...baseStyles, { textDecoration: 'underline' }]}>{char}</Text>
                </Link>
              )),
              // <Image
              //   key={`${index}-icon`}
              //   src={extLinkImg}
              //   style={{ width: 8, height: 8, marginLeft: 4, marginRight: 4 }}
              // />,
            ]
          : part.split('').map((char, charIndex) => (
              <Text key={`${index}-${charIndex}`} style={style}>
                {char}
              </Text>
            )),
      )}
    </View>
  );
};
